import React from "react";
import useProductBulkUpload from "../../customHooks/ProductBulkUpload/useProductBulkUpload";
import { Modal } from "react-bootstrap";
import { Loader as LoaderIcon } from "react-feather";
import { IoCloudUploadOutline } from "react-icons/io5";
import { IoArrowBackCircle } from "react-icons/io5";

const ProductBulkUpload = ({ isOpen, onClose }) => {
  const talonProps = useProductBulkUpload();
  const {
    handleFileChange,
    invalidRows,
    error,
    setInvalidRows,
    setError,
    setOpenMessage,
    handleDownload,
    uploadProducts,
    bulkLoader,
    rejectedRows,
    openMessage,
    setRejectedRows,
    inputFile,
    createstatus,
    setProductJson,
    setInputFile,
    handleVariantDownload,
    isProduct,
    setIsProduct,
  } = talonProps;

  return (
    <>
      <Modal
        show={isOpen}
        onHide={() => {
          setOpenMessage(false);
          setError("");
          setInvalidRows([]);
          onClose();
          setInputFile(null);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <div className="flex justify-between items-center w-full">
            <Modal.Title className="text-lg font-bold">
              Upload Product
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12">
            {!openMessage ? (
              <div className="space-y-4 p-4 ">
                <div className="flex justify-end space-x-4">
                  <button
                    className="bg-blue-500 text-white font-semibold p-2 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition"
                    onClick={handleDownload}
                  >
                    Download Product Sample CSV
                  </button>

                  <button
                    className="bg-blue-500 text-white font-semibold p-2 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition"
                    onClick={handleVariantDownload}
                  >
                    Download Variant Sample CSV
                  </button>
                </div>
                <div className="flex justify-center flex-col">
                  <div className={`filterbox mb-4 `}>
                    <h1 className="mb-2">Select the type you want to upload</h1>
                    <select
                      name="bIsProduct"
                      value={isProduct}
                      onChange={(e) => setIsProduct(e.target.value)}
                      className="p-2 border rounded-md w-full"
                      // disabled={!isBulk}
                    >
                      <option value="">Select Option</option>
                      <option value={"product"}>Product</option>
                      <option value={"variant"}>Variant</option>
                    </select>
                  </div>
                  <div
                    className={`border-2 bg-gray-200 border-dashed rounded-md p-6 transition duration-200 border-gray-400 hover:border-blue-500 flex justify-center items-center`}
                  >
                    <input
                      type="file"
                      multiple
                      onChange={handleFileChange}
                      className="hidden"
                      id="file-upload"
                      accept=".csv"
                    />
                    <label
                      htmlFor="file-upload"
                      className="flex flex-col items-center cursor-pointer text-blue-600 hover:text-blue-800"
                    >
                      <IoCloudUploadOutline size={20} className="mb-2" />
                      {inputFile?.name || "Choose CSV file to upload"}
                    </label>
                  </div>

                  <div className="flex flex-col ml-4 ">
                    {error ? (
                      <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded mb-4">
                        <p>{error}</p>
                      </div>
                    ) : null}
                    {invalidRows.length > 0 && (
                      <div className="rounded">
                        <h5 className="font-bold mb-2">
                          Invalid Rows (Missing Fields):
                        </h5>
                        <div className="overflow-x-auto">
                          <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
                            <thead className="text-left">
                              <tr>
                                <th className="px-4 py-2 border">Row No</th>
                                <th className="px-4 py-2 border">SKU</th>
                                <th className="px-4 py-2 border">
                                  Missing Fields
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {invalidRows.map((row, idx) => {
                                const missingFields = [
                                  !row.SKU && "SKU",
                                  !row.Brand && "Brand",
                                  !row.Name && "Name",
                                  !row.Gender && "Gender",
                                  !row.ProductType && "ProductType",
                                  row.ProductType?.toLowerCase() === "ear" &&
                                    !row.Height &&
                                    "Height",
                                  row.ProductType?.toLowerCase() === "ear" &&
                                    !row.Width &&
                                    "Width",
                                ].filter(Boolean);
                                return (
                                  <tr
                                    key={idx}
                                    className="bg-white hover:bg-gray-100"
                                  >
                                    <td className="px-4 py-2 border">
                                      {row.rowIndex}
                                    </td>
                                    <td className="px-4 py-2 border">
                                      {row.SKU}
                                    </td>
                                    <td className="px-4 py-2 border">
                                      {missingFields.join(", ")}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex justify-center">
                  {bulkLoader ? (
                    <button
                      className="screenFormSubmitLoaderBtn consistentBtn"
                      style={{ width: "100px" }}
                      disabled={bulkLoader}
                    >
                      <LoaderIcon size={20} className="indicator" />
                    </button>
                  ) : (
                    <>
                      <div className="flex justify-end space-x-4 mt-4">
                        <button
                          className="bg-blue-500 text-white font-semibold px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 disabled:bg-gray-400 disabled:cursor-not-allowed"
                          disabled={
                            invalidRows.length > 0 || !inputFile || error
                          }
                          onClick={uploadProducts}
                        >
                          Upload Products
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <>
                {rejectedRows?.length > 0 ? (
                  <div className="p-6">
                    <div className="mb-2 flex justify-end ">
                      <button
                        className="bg-blue-500 text-white font-semibold p-2 rounded-lg focus:outline-none flex justify-between items-center gap-2"
                        onClick={() => {
                          setOpenMessage(false);
                          setRejectedRows([]);
                          setInvalidRows([]);
                          setProductJson([]);
                          setInputFile(null);
                        }}
                      >
                        <IoArrowBackCircle size={20} />
                        Back
                      </button>
                    </div>
                    <div className="mb-2 text-gray-700">
                      The following are rejected rows; please upload the file
                      again.
                    </div>
                    <div className="rounded-lg bg-white shadow-md">
                      <h5 className="font-bold mb-2 text-gray-800">
                        Rejected Rows
                      </h5>
                      <div className="overflow-x-auto">
                        <table className="min-w-full table-auto bg-white border border-gray-300 rounded-lg">
                          <thead className="bg-gray-200">
                            <tr>
                              <th className="px-4 py-2 border">SKU</th>
                              <th className="px-4 py-2 border">Errors</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rejectedRows.map((row, idx) => (
                              <tr
                                key={idx}
                                className="bg-white hover:bg-gray-100"
                              >
                                <td className="px-4 py-2 border">{row.sSKU}</td>
                                <td className="px-4 py-2 border">
                                  {row.errors.join(", ")}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* <div className="mt-4">
                      <button
                        className="bg-blue-500 text-white font-semibold px-4 py-2 rounded-lg focus:outline-none"
                        onClick={() => {
                          onClose();
                          setOpenMessage(false);
                        }}
                      >
                        Close
                      </button>
                    </div> */}
                  </div>
                ) : (
                  <div className="flex flex-col items-center p-6">
                    <span className="text-center">{createstatus}</span>
                    {/* <div className="mt-4">
                      <button
                        className="bg-blue-500 text-white font-semibold px-4 py-2 rounded-lg focus:outline-none"
                        onClick={() => {
                          fetchProducts();
                          onClose();
                          setOpenMessage(false);
                        }}
                      >
                        Close
                      </button>
                    </div> */}
                  </div>
                )}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProductBulkUpload;
